// 平台协议相关路由
export default {
  routes: [
    {
      path: '/(\\s*)platformRules(\\d*)/(\\s*)rulesSetIndex(\\d*)',
      name: 'rulesSetIndex',
      meta: {
        desc: '规则集合页'
      },
      component: () =>
        import(/* webpackChunkName: "rulesSetIndex" */ '../views/platformRules/rulesSetIndex.vue')
    },
    {
      path: '/(\\s*)platformRules(\\d*)/(\\s*)rulesList(\\d*)',
      name: 'rulesList',
      meta: {
        desc: '具体规则列表页'
      },
      component: () =>
        import(/* webpackChunkName: "rulesList" */ '../views/platformRules/rulesList.vue')
    },
    {
      path: '/(\\s*)platformRules(\\d*)/(\\s*)rulesContent(\\d*)',
      name: 'rulesContent',
      meta: {
        desc: '具体规则内容页'
      },
      component: () =>
        import(/* webpackChunkName: "rulesContent" */ '../views/platformRules/rulesContent.vue')
    }
  ]
}
